import { styled } from '@mui/material/styles';
import { Box, Paper, Typography } from '@mui/material';

export const MobileNavListContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  zIndex: 4,
  top: 0,
  height: '100%',
  width: '100%',
  backgroundColor: `${theme.palette.primary.light}`,
  display: 'inline-grid',
  alignItems: 'center',
}));

export const MobileNavBackDrop = styled(Box)(({ theme }) => ({
  width: '100vw',
  height: '90vh',

  position: 'absolute',
  top: '60px',
  left: '0',

  background: `${theme.palette.primary.light}`,
}));

export const ProfileIconWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  cursor: 'pointer',
  zIndex: '5',
  height: '40px',
  width: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgrounduColor: 'white',
  borderRadius: '10px',
  margin: '0px 5px',

  '& > img': {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    cursor: 'pointer',
    margin: '0px 5px',
    animation: 'opacity-transition 2.5s ease-in-out 0s reverse',
  },
}));

export const MenuuIconWrapper = styled(Box)(({ theme }) => ({
  width: '35px',
  height: '35px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const NavTitle = styled(Typography)(({ theme }) => ({
  marginLeft: '10px',
  color: '#0f1177',
  '@media (min-width: 1536px)': {
    fontSize: '17px',
  },
  '@media (min-width: 1200px) and (max-width: 1536px)': {
    fontSize: '16.5px',
  },
  '@media (min-resolution: 1.5dppx)': {
    '@media (max-height: 675px)': {
      fontSize: '13px !important',
    },
  },
}));

export const HealthBarOuter = styled(Box)(({ theme }) => ({
  width: '80%',
  height: '8px',
  borderRadius: '4px',
  minWidth: '125px',

  [theme.breakpoints.up('md')]: {
    minWidth: '200px',
    maxWidth: '250px',
    marginTop: '0.5em',
    marginBottom: '0.80em',
  },

  [theme.breakpoints.up('xl')]: {
    marginBottom: '2em',
  },
}));

export const HealthBarInner = styled(Box)(({ theme }) => ({}));
